/* eslint-disable no-shadow */
import iziToast from "izitoast";

export default function install(Vue) {
  Object.defineProperties(Vue.prototype, {
    $iziToast: {
      get() {
        iziToast.settings({
          position: "topRight",
          title: "NCM Helper",
          layout: 2,
        });
        return iziToast;
      },
    },
  });
}
